import NewReleaseAllProducts from './new-release-all-products';

export * from './new-release-all-products';
export default NewReleaseAllProducts;
